import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth.js";

export function LoginPage() {
  const auth = useAuth();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      const role = await auth.login(pw);
      nav(role === "admin" ? "/admin" : "/", { replace: true });
    } catch {
      setErr("Forkert kodeord");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-full flex items-center justify-center p-6">
      <form
        onSubmit={submit}
        className="w-full max-w-sm space-y-4 bg-neutral-900 p-6 rounded-2xl border border-neutral-800"
      >
        <h1 className="text-2xl font-bold">MMA Stats Tracker</h1>
        <p className="text-neutral-400 text-sm">
          Indtast adgangskode (spotter eller admin).
        </p>
        <input
          type="password"
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          autoFocus
          className="w-full bg-neutral-800 rounded-lg px-4 py-3 text-lg outline-none focus:ring-2 ring-blue-500"
          placeholder="Kodeord"
        />
        {err && <div className="text-red-400 text-sm">{err}</div>}
        <button
          type="submit"
          disabled={busy || !pw}
          className="tap-btn w-full bg-blue-600 hover:bg-blue-500 disabled:opacity-50 text-white py-3 text-lg"
        >
          {busy ? "Logger ind…" : "Log ind"}
        </button>
      </form>
    </div>
  );
}
